import React from "react";
import { useNavigate } from "react-router-dom";

const AuthWrapper = ({ children }:any) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    }
    
  }, [navigate]);

  return <>{children}</>;
};

export default AuthWrapper;